import  Aboutus  from "../AboutScreen/Aboutus";
import  {CafeSection } from "./CafeSection";
import CardsPage from "./CardsPage/CardsPage";
import {DiscoverPage} from "./DiscoverPage";
import {LandingPage} from "./LandingPage";
import {MenuLayout } from "./MenuLayout";
import  {StoryPage } from "./StoryPage";

const HomeScreen = () => {
  return (
    <>
      <LandingPage />
      <DiscoverPage />
      <CafeSection />
      <StoryPage />
      <MenuLayout />
      <CardsPage />
      <Aboutus />
    </>
  );
};

export default HomeScreen;